(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Publishes the real height of everything above the hero as --bh-header-h, so the hero's
   * `min-height: calc(100svh - var(--bh-header-h))` is arithmetic rather than a guess.
   *
   * Measured, not hardcoded, because that stack changes: the announcement bar can be switched
   * off, the nav can wrap to a second row at some widths, and the logo size is a theme-editor
   * setting. A constant is correct until someone touches any of those.
   *
   * The hero's offset from the top of the DOCUMENT is exactly "everything above it", which is
   * what we want — and it stays correct for a sticky header, since a sticky element still
   * occupies its space in flow.
   */
  (function () {
    var hero = document.querySelector('.bh-hero');
    if (!hero) return;

    var last = -1;
    function measure() {
      var top = Math.round(hero.getBoundingClientRect().top + window.scrollY);
      if (top === last) return;           // avoid pointless style writes -> layout thrash
      last = top;
      document.documentElement.style.setProperty('--bh-header-h', top + 'px');
    }

    measure();
    addEventListener('resize', measure, { passive: true });
    // Webfonts and the logo can reflow the header after first paint.
    addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    // Anything above the hero changing size (nav wrapping, announcement bar closing) must
    // re-measure. Observing the hero's own previous siblings covers all of it.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      var node = hero.closest('.shopify-section') || hero;
      while ((node = node.previousElementSibling)) ro.observe(node);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-review-rail"] && !Shopify.designMode) return;
  try {
    
  // Scrolls the track by one "page" and keeps the arrows honest about whether there is
  // anywhere left to go. No wrap-around: unlike the 2-3 photos in a card gallery, this track
  // is a dozen cards, and silently jumping back to the start reads as a glitch.
  (() => {
    const rails = document.querySelectorAll('[data-bh-rail-track]');
    rails.forEach((track) => {
      const nav = track.closest('.bh-rrail')?.querySelector('[data-bh-rail-nav]');
      if (!nav) return;
      const prev = nav.querySelector('[data-bh-rail-dir="prev"]');
      const next = nav.querySelector('[data-bh-rail-dir="next"]');

      const sync = () => {
        // 1px of slack: fractional scroll offsets never land exactly on the end.
        const overflows = track.scrollWidth - track.clientWidth > 1;
        nav.hidden = !overflows;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      const page = () => Math.max(track.clientWidth * 0.85, 260);
      prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      // Fires once on observe, which doubles as the initial state, and again whenever the
      // cards reflow (a photo landing changes a card's height, not width, but the breakpoint
      // swap from 300px to 78vw does change the overflow).
      new ResizeObserver(sync).observe(track);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
	function init(root) {
		if (root.dataset.faqReady) return;
		root.dataset.faqReady = '1';
		var items = Array.prototype.slice.call(root.querySelectorAll('.faq-accordion__item'));
		function ansOf(d) { return d.querySelector('.faq-accordion__ans'); }
		function closeItem(d) {
			var a = ansOf(d); if (!a) { d.open = false; return; }
			a.style.height = a.scrollHeight + 'px';
			requestAnimationFrame(function () { a.style.height = '0px'; });
			a.addEventListener('transitionend', function h(e) { if (e.propertyName !== 'height') return; d.open = false; a.style.height = ''; a.removeEventListener('transitionend', h); });
		}
		function openItem(d) {
			var a = ansOf(d); if (!a) { d.open = true; return; }
			d.open = true;
			var t = a.scrollHeight; a.style.height = '0px';
			requestAnimationFrame(function () { a.style.height = t + 'px'; });
			a.addEventListener('transitionend', function h(e) { if (e.propertyName !== 'height') return; a.style.height = 'auto'; a.removeEventListener('transitionend', h); });
		}
		items.forEach(function (d) {
			var ans = ansOf(d);
			if (d.open && ans) ans.style.height = 'auto';
			var sum = d.querySelector('summary');
			if (!sum) return;
			sum.addEventListener('click', function (e) {
				e.preventDefault();
				if (d.open) { closeItem(d); }
				else { items.forEach(function (o) { if (o !== d && o.open) closeItem(o); }); openItem(d); }
			});
		});
		var links = Array.prototype.slice.call(root.querySelectorAll('.faq-accordion__nav a'));
		if (links.length) {
			links.forEach(function (l) {
				l.addEventListener('click', function (e) {
					var id = l.getAttribute('data-spy');
					var t = id && document.getElementById(id);
					if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
				});
			});
			if ('IntersectionObserver' in window) {
				var map = {}; links.forEach(function (l) { map[l.getAttribute('data-spy')] = l; });
				var obs = new IntersectionObserver(function (ents) {
					ents.forEach(function (en) {
						if (en.isIntersecting) {
							links.forEach(function (l) { l.classList.remove('is-active'); });
							if (map[en.target.id]) map[en.target.id].classList.add('is-active');
						}
					});
				}, { rootMargin: '-25% 0px -65% 0px' });
				root.querySelectorAll('.faq-accordion__cat').forEach(function (c) { obs.observe(c); });
			}
		}
	}
	function boot() { document.querySelectorAll('.faq-accordion').forEach(init); }
	if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
	document.addEventListener('shopify:section:load', function (e) {
		if (e.target && e.target.querySelectorAll) { e.target.querySelectorAll('.faq-accordion').forEach(init); }
	});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!form || form.id !== "cart-form") return;
    // Quantity changes submit this same form; only the checkout press should go busy.
    if (event.submitter?.name !== "checkout") return;

    if (form.dataset.bhSubmitting === "true") {
      event.preventDefault();
      return;
    }
    form.dataset.bhSubmitting = "true";

    document
      .querySelectorAll('button[name="checkout"], [data-bh-sticky-checkout]')
      .forEach((btn) => btn.setAttribute("aria-busy", "true"));
  });

  } catch(e) { console.error(e); }
})();
})();
